module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/info.59f8bbca.svg";